import React, { useState } from "react";
import { Dropdown, Button } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import ReceptionistLayout from "../../Layouts/Receptionist/ReceptionistLayout";
import ConfirmAppointmentModal from "../../Components/Receptionist/Appointment/ConfirmAppointmentModal";
import RescheduleAppointmentModal from "../../Components/Receptionist/Appointment/RescheduleAppointmentModal";
import RejectAppointmentModal from "../../Components/Receptionist/Appointment/RejectAppointmentModal";

export default function ReceptionistAppointments() {

    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [isRescheduleModalOpen, setIsRescheduleModalOpen] = useState(false);
    const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
    const [selectedAppointment, setSelectedAppointment] = useState(null);

    const [filters, setFilters] = useState({
        patient: "",
        consultationType: "New",
        status: "",
        date: "",
    });

    const appointments = [
        {
            token: "01",
            patient: "Ravi Kumar",
            phone: "9876543210",
            requestedDate: "12 Aug 2026",
            doctor: "Dr. Mithra",
            doctorAvatar: "https://i.pravatar.cc/40?img=12",
            createdOn: "28 Feb 2026",
            createdTime: "10:30 AM",
            status: "Waiting",
        },
        {
            token: "02",
            patient: "Meena",
            phone: "9123456780",
            requestedDate: "2 Mar 2026",
            doctor: "Dr. Anandi Gopal Joshi",
            doctorAvatar: "https://i.pravatar.cc/40?img=32",
            createdOn: "25 Feb 2026",
            createdTime: "11:00 AM",
            status: "Confirmed",
        },
        {
            token: "03",
            patient: "Harini",
            phone: "9123300780",
            requestedDate: "2 Mar 2026",
            doctor: "Dr. Niveditha K J",
            doctorAvatar: "https://i.pravatar.cc/40?img=21",
            createdOn: "25 Mar 2026",
            createdTime: "11:00 AM",
            status: "Rescheduled",
        },
        {
            token: "04",
            patient: "Madhumitha",
            phone: "91267456780",
            requestedDate: "2 Mar 2026",
            doctor: "Dr. Niveditha K J",
            doctorAvatar: "https://i.pravatar.cc/40?img=24",
            createdOn: "20 Feb 2026",
            createdTime: "11:00 AM",
            status: "Confirmed",
        },
        {
            token: "05",
            patient: "Janani",
            phone: "8123456780",
            requestedDate: "6 Mar 2026",
            doctor: "Dr. Anandi Gopal Joshi",
            doctorAvatar: "https://i.pravatar.cc/40?img=15",
            createdOn: "5 Mar 2026",
            createdTime: "11:00 AM",
            status: "Confirmed",
        },
    ];

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const getStatusBadge = (status) => {
        switch (status?.toLowerCase()) {
            case "confirmed":
                return "badge badge-light-success text-success fw-bold px-3 py-2 rounded-pill";
            case "waiting":
                return "badge badge-light-warning text-warning fw-bold px-3 py-2 rounded-pill";
            case "rescheduled":
                return "badge badge-light-primary text-primary fw-bold px-3 py-2 rounded-pill";
            case "rejected":
                return "badge badge-light-danger text-danger fw-bold px-3 py-2 rounded-pill";
            default:
                return "badge badge-light-secondary text-secondary fw-bold px-3 py-2 rounded-pill";
        }
    };

    const getActionItems = (record) => [
        {
            key: "confirm",
            label: (
                <span className="d-flex align-items-center gap-2">
                    <i className="bi bi-check-lg text-success"></i>
                    Confirm
                </span>
            ),
            onClick: () => handleMenuClick("confirm", record),
        },
        {
            key: "reschedule",
            label: (
                <span className="d-flex align-items-center gap-2">
                    <i className="bi bi-calendar-event text-primary"></i>
                    Reschedule
                </span>
            ),
            onClick: () => handleMenuClick("reschedule", record),
        },
        {
            key: "reject",
            label: (
                <span className="d-flex align-items-center gap-2">
                    <i className="bi bi-x-circle text-danger"></i>
                    Reject
                </span>
            ),
            onClick: () => handleMenuClick("reject", record),
        },
    ];

    const handleMenuClick = (action, record) => {
        if (action === "confirm") {
            setSelectedAppointment(record);
            setIsConfirmModalOpen(true);
        }

        if (action === "reschedule") {
            setSelectedAppointment(record);
            setIsRescheduleModalOpen(true);
        }

        if (action === "reject") {
            setSelectedAppointment(record);
            setIsRejectModalOpen(true);
        }
    };

    const handleConfirmAppointment = (data) => {
        console.log("Confirmed Appointment Data:", data);
    };

    const handleRescheduleAppointment = (data) => {
        console.log("Rescheduled Appointment Data:", data);
    };

    const handleRejectAppointment = (data) => {
        console.log("Reject Appointment Data:", data);
    };



    return (
        <>
            <ReceptionistLayout>
                <div className="row g-4">
                    <div className="col-12">
                        <div className="card border-0 rounded-4 shadow-sm">
                            <div className="card-header bg-white border-0 pt-5 pb-0">
                                <div className="w-100">
                                    <div className="bg-light-primary text-primary fw-bold px-4 py-3 rounded-3 fs-7 text-uppercase">
                                        Filter Parameters
                                    </div>
                                </div>
                            </div>

                            <div className="card-body p-4">
                                <div className="row g-3">
                                    <div className="col-12 col-md-6 col-xl-3">
                                        <label className="form-label fw-semibold text-muted fs-8 text-uppercase mb-1">
                                            Patient Name
                                        </label>
                                        <input
                                            type="text"
                                            name="patient"
                                            className="form-control form-control-sm"
                                            placeholder="Search by Patient Name or Phone"
                                            value={filters.patient}
                                            onChange={handleFilterChange}
                                        />
                                    </div>

                                    <div className="col-12 col-md-6 col-xl-3">
                                        <label className="form-label fw-semibold text-muted fs-8 text-uppercase mb-1">
                                            Consultation Type
                                        </label>
                                        <select
                                            name="consultationType"
                                            className="form-select form-select-sm"
                                            value={filters.consultationType}
                                            onChange={handleFilterChange}
                                        >
                                            <option value="New">New</option>
                                            <option value="Follow Up">Follow Up</option>
                                            <option value="Emergency">Emergency</option>
                                        </select>
                                    </div>

                                    <div className="col-12 col-md-6 col-xl-3">
                                        <label className="form-label fw-semibold text-muted fs-8 text-uppercase mb-1">
                                            Status
                                        </label>
                                        <select
                                            name="status"
                                            className="form-select form-select-sm"
                                            value={filters.status}
                                            onChange={handleFilterChange}
                                        >
                                            <option value="">All Status</option>
                                            <option value="Confirmed">Confirmed</option>
                                            <option value="Waiting">Waiting</option>
                                            <option value="Rescheduled">Rescheduled</option>
                                            <option value="Rejected">Rejected</option>
                                        </select>
                                    </div>

                                    <div className="col-12 col-md-6 col-xl-3">
                                        <label className="form-label fw-semibold text-muted fs-8 text-uppercase mb-1">
                                            Date
                                        </label>
                                        <input
                                            type="date"
                                            name="date"
                                            className="form-control form-control-sm"
                                            value={filters.date}
                                            onChange={handleFilterChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="card border-0 rounded-4 shadow-sm">
                            <div className="card-body p-4 p-lg-5">
                                <div className="table-responsive">
                                    <table className="table align-middle table-row-dashed gy-4 mb-0">
                                        <thead>
                                            <tr
                                                className="fw-bold text-dark"
                                                style={{ backgroundColor: "#dbe8fb" }}
                                            >
                                                <th className="ps-5">Token</th>
                                                <th>Patient</th>
                                                <th>Phone</th>
                                                <th>Requested Date</th>
                                                <th>Preferred Doctor</th>
                                                <th>Created on</th>
                                                <th>Status</th>
                                                <th className="text-center">Action</th>
                                            </tr>
                                        </thead>

                                        <tbody className="fw-semibold text-gray-700">
                                            {appointments.map((item) => (
                                                <tr key={item.token}>
                                                    <td className="ps-5">{item.token}</td>
                                                    <td className="fw-bold text-dark">{item.patient}</td>
                                                    <td>{item.phone}</td>
                                                    <td>{item.requestedDate}</td>
                                                    <td>
                                                        <div className="d-flex align-items-center gap-3">
                                                            <img
                                                                src={item.doctorAvatar}
                                                                alt={item.doctor}
                                                                className="rounded-circle"
                                                                style={{
                                                                    width: "34px",
                                                                    height: "34px",
                                                                    objectFit: "cover",
                                                                }}
                                                            />
                                                            <span className="fw-bold text-dark">{item.doctor}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex flex-column">
                                                            <span>{item.createdOn}</span>
                                                            <span className="text-muted fs-8">{item.createdTime}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <span className={getStatusBadge(item.status)}>
                                                            {item.status}
                                                        </span>
                                                    </td>
                                                    <td className="text-center">
                                                        <Dropdown
                                                            menu={{ items: getActionItems(item) }}
                                                            trigger={["hover"]}
                                                            placement="bottomRight"
                                                        >
                                                            <Button
                                                                type="text"
                                                                icon={<MoreOutlined />}
                                                                className="btn btn-sm btn-light"
                                                            />
                                                        </Dropdown>
                                                    </td>
                                                </tr>
                                            ))}

                                            {appointments.length === 0 && (
                                                <tr>
                                                    <td colSpan="8" className="text-center py-10 text-muted fw-semibold">
                                                        No appointments found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ReceptionistLayout>

            <ConfirmAppointmentModal
                open={isConfirmModalOpen}
                onClose={() => setIsConfirmModalOpen(false)}
                onConfirm={handleConfirmAppointment}
                appointment={selectedAppointment}
            />

            <RescheduleAppointmentModal
                open={isRescheduleModalOpen}
                onClose={() => setIsRescheduleModalOpen(false)}
                onSubmit={handleRescheduleAppointment}
                appointment={selectedAppointment}
            />

            <RejectAppointmentModal
                open={isRejectModalOpen}
                onClose={() => setIsRejectModalOpen(false)}
                onSubmit={handleRejectAppointment}
                appointment={selectedAppointment}
            />


        </>

    );
}
